import { render, staticRenderFns } from "./PrivateAreaConfigPane.vue?vue&type=template&id=29eb9956&scoped=true"
import script from "./PrivateAreaConfigPane.vue?vue&type=script&lang=js"
export * from "./PrivateAreaConfigPane.vue?vue&type=script&lang=js"
import style0 from "./PrivateAreaConfigPane.vue?vue&type=style&index=0&id=29eb9956&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eb9956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29eb9956')) {
      api.createRecord('29eb9956', component.options)
    } else {
      api.reload('29eb9956', component.options)
    }
    module.hot.accept("./PrivateAreaConfigPane.vue?vue&type=template&id=29eb9956&scoped=true", function () {
      api.rerender('29eb9956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/PrivateArea/PrivateAreaConfigPane.vue"
export default component.exports